import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { FEATURE } from "../store/video/video.type";
import { Checkbox } from "primereact/checkbox";

const FeatureToggle = ({
  type,
  row,
  updateFeature,
  updateHashtag,
  page,
  size,
  startDate,
  endDate,
}) => {
  const [checked, setChecked] = useState(Boolean(row?.feature));

  useEffect(() => {
    setChecked(Boolean(row?.feature));
  }, [row?.feature]);

  const handleChange = (event) => {
    const newValue = event.target.checked; // Get the new checked value from the event
    setChecked(newValue);

    if (type === "video") {
      const data = [{ uniqueVideoId: row?.uniqueVideoId, feature: newValue }];
      updateFeature(data, 1, page, size, startDate, endDate);
    } else if (type === "hashtag") {
      const data = [{ uniqueVideoId: row?.uniqueVideoId, feature: newValue }];
      updateHashtag(data, page, size);
    } else if (type === "short") {
      const data = [{ uniqueVideoId: row?.uniqueVideoId, feature: newValue }];
      updateFeature(data, 2, page, size, startDate, endDate);
    } else if (type === "channel") {
      updateFeature(
        row._id,
        newValue,
        page,
        size,
        startDate,
        endDate,
        "realUser"
      );
    }
  };

  return <input type="checkbox" onChange={handleChange} checked={checked} />;
};

export default FeatureToggle;
